const MyAccount = () => {
  return (
    <div className="page-title">
      <h1>My Account</h1>
    </div>
  );
};

export default MyAccount;
